import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

const FINISHES = ["Letterpress", "Hot Foil", "Deboss", "White Ink", "Soft Touch", "32pt Cotton"];

export function WeddingHero({ groups, count }) {
  return (
    <section className="relative bg-[#F7F1E8] text-[#2C3340] overflow-hidden" data-testid="wedding-hero">
      <div className="absolute inset-0 opacity-[0.5] pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 80% 20%, #E8D9C3 0, transparent 45%), radial-gradient(circle at 10% 90%, #EFE4D3 0, transparent 40%)" }} />
      <div className="container-page relative py-10 lg:py-16 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <nav aria-label="Breadcrumb" className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#2C3340]/55 mb-5" data-testid="category-breadcrumb">
            <Link to="/" className="hover:text-[#2C3340]">Home</Link><span className="mx-2">/</span>
            <Link to="/shop" className="hover:text-[#2C3340]">Shop</Link><span className="mx-2">/</span>
            <Link to="/shop/digital-print" className="hover:text-[#2C3340]">Marketing Materials</Link><span className="mx-2">/</span>
            <span className="text-[#2C3340]">Wedding Stationery</span>
          </nav>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-kolt-orange" />
            <span className="font-mono text-[11px] tracking-[0.3em] font-bold uppercase text-kolt-orange">Wedding Stationery · Printed to order in Houston</span>
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]" data-testid="shop-title">
            Wedding Invitations &amp; Stationery
            <span className="block text-[#8A6A4B] font-normal italic text-2xl sm:text-3xl lg:text-4xl mt-2" style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}>letterpress, foil &amp; cotton — the whole suite, one press</span>
          </h1>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-[#2C3340]/80 max-w-xl">
            From save-the-dates to table numbers, every piece is printed on the same Mohawk, Colorplan or 100% cotton stock so the suite matches perfectly. Choose real letterpress, hot foil, deboss, white ink on dark paper or velvety soft-touch — every order includes a free proof from a real prepress designer.
          </p>
          <div className="mt-5 flex flex-wrap gap-2" data-testid="wedding-finish-chips">
            {FINISHES.map((f) => (
              <span key={f} className="font-mono text-[10px] tracking-[0.18em] uppercase border border-[#2C3340]/20 bg-white/60 px-3 py-1.5">{f}</span>
            ))}
          </div>
          <div className="mt-7 flex flex-wrap gap-3">
            <a href="#invitations" className="btn-primary inline-flex items-center gap-2" data-testid="wedding-cta-invitations">
              Shop invitations <ArrowUpRight className="w-4 h-4" />
            </a>
            <Link to="/quote?product=wedding-sample-pack" className="inline-flex items-center gap-2 border-2 border-[#2C3340] px-5 py-3 font-mono text-xs tracking-[0.2em] uppercase font-bold hover:bg-[#2C3340] hover:text-white transition-colors" data-testid="wedding-cta-sample">
              <Sparkles className="w-4 h-4" /> Request a sample pack
            </Link>
          </div>
          <div className="mt-6 font-mono text-[10px] tracking-[0.2em] uppercase text-[#2C3340]/55">
            {count} pieces · from $0.60 · free digital proof · ships nationwide
          </div>
        </div>
        <div className="lg:col-span-6">
          <div className="relative">
            <img src="/wedding/hero-suite.jpg" alt="Letterpress and foil wedding invitation suite with envelopes, RSVP and place cards on ivory linen" className="w-full aspect-[3/2] object-cover shadow-[16px_16px_0_#E8D9C3]" width="1264" height="848" fetchpriority="high" />
            <div className="absolute -bottom-4 left-4 bg-[#2C3340] text-white px-4 py-2 font-mono text-[10px] tracking-[0.22em] uppercase">Real cotton · real impression</div>
          </div>
        </div>
      </div>
      <div className="border-t border-[#2C3340]/10 bg-[#F2EADF]">
        <div className="container-page flex gap-1 overflow-x-auto py-2" data-testid="wedding-anchor-nav">
          {groups.map((g) => (
            <a key={g.id} href={`#${g.id}`} className="shrink-0 font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-2 hover:text-kolt-orange" data-testid={`wedding-anchor-${g.id}`}>
              {g.title} <span className="text-[#2C3340]/40">({g.items.length})</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
